
import { RevLink } from '@ds/components/Link'

import FormattedMessage from '@i18n/components/FormattedMessage'
import { ROUTES } from '@router'

import translations from './SEOText.translations'

export default {
  components: {
    FormattedMessage,
    RevLink,
  },

  data() {
    return { isCollapsed: true }
  },

  computed: {
    translations: () => translations,

    toggleLabel() {
      return this.isCollapsed ? translations.seeMore : translations.seeLess
    },

    routeTarget() {
      return { name: ROUTES.ABOUT_US }
    },
  },

  created() {
    // data-selector attribute used by the SEO team to check SEO elements are available
    this.SEO_TEXT_DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'reviews-text'
  },

  methods: {
    toggleCollapsedState() {
      this.isCollapsed = !this.isCollapsed
    },
  },
}
